import { render } from "./ArticlesMenu.vue?vue&type=template&id=47546408&ts=true"
import script from "./ArticlesMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticlesMenu.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/ArticlesMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47546408"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47546408', __exports__)) {
    api.reload('47546408', __exports__)
  }
  
  module.hot.accept("./ArticlesMenu.vue?vue&type=template&id=47546408&ts=true", () => {
    api.rerender('47546408', render)
  })

}


export default __exports__